exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-select{padding-top:45px}.page-select .mint-button{margin-top:15px}.page-select-wrapper{background-color:#fff}.page-select-desc{margin:10px 0 50px}.page-title{font-size:20px;margin:0 auto;padding:20px 0;text-align:center;display:block;line-height:1}.page-item-title{text-align:center;color:#666;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ab8a362","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/pages/select.vue
// module id = 602
// module chunks = 0